// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Replace this config object with your own Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyC_lOMJoVNh-J1APxid-RtyTToHGr8QthE",
  authDomain: "arti-ec62c.firebaseapp.com",
  projectId: "arti-ec62c",
  storageBucket: "arti-ec62c.appspot.com",
  messagingSenderId: "905626874094",
  appId: "1:905626874094:web:024ac69ed9078a18ad83ff"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);